import React from 'react'

// Shared button. Defaults to the global theme color (navy gradient) via the
// `cmn_btn` base class (styled in src/styles/theme.css). Pass `variant`
// ('primary' | 'secondary' | 'danger' | 'white', default primary) to switch
// the look, or a `className` for one-off overrides.
function CommonButton({ type, text, className, onClick, id, disable, variant, ...rest }) {
    const variantClass = variant && variant !== 'primary' ? `cmn_btn--${variant}` : '';
    return (
        <div className='common_button'>
            <button
                onClick={onClick}
                type={type}
                disabled={disable}
                className={`cmn_btn ${variantClass} ${className || ''}`.replace(/\s+/g, ' ').trim()}
                id={id}
                {...rest}
            >
                {text}
            </button>
        </div >
    )
}

export default CommonButton
